/**
 * Pre-compiled localized messages for ScopedSearchInput component
 *
 * Generated by scripts/generate-dictionaries.ts
 * DO NOT EDIT MANUALLY
 *
 * @see https://react-spectrum.adobe.com/react-aria/internationalization.html
 */

import {
  type LocalizedString,
  type LocalizedStrings,
} from "@internationalized/string";
import { normalizeMessages } from "../../utils/normalize-messages";

// Pre-compiled message functions
import scopedSearchInputMessages_en from "./intl/en";
import scopedSearchInputMessages_de from "./intl/de";
import scopedSearchInputMessages_es from "./intl/es";
import scopedSearchInputMessages_fr from "./intl/fr-FR";
import scopedSearchInputMessages_pt from "./intl/pt-BR";

// Raw LocalizedStrings object for use with useLocalizedStringFormatter hook
export const scopedSearchInputMessagesStrings: LocalizedStrings<
  string,
  LocalizedString
> = {
  en: normalizeMessages(scopedSearchInputMessages_en),
  de: normalizeMessages(scopedSearchInputMessages_de),
  es: normalizeMessages(scopedSearchInputMessages_es),
  "fr-FR": normalizeMessages(scopedSearchInputMessages_fr),
  "pt-BR": normalizeMessages(scopedSearchInputMessages_pt),
} as LocalizedStrings<string, LocalizedString>;

/**
 * Available message keys for ScopedSearchInput component
 */
export type ScopedSearchInputMessageKey = "searchLabel" | "selectLabel";
